<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="그룹 관리" device="web">
        <template v-slot:body>
          <DxDataGrid
            id="groupDataGrid"
            class="layout-col-height00"
            width="100%"
            :ref="dxDataGridRef"
            :data-source="groups"
            :remote-operations="false"
            :hover-state-enabled="true"
            :allow-column-resizing="true"
            :allow-column-reordering="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-row-lines="true"
            :focused-row-enabled="true"
            key-expr="id"
            @row-updating="onRowUpdating"
            @editing-start="onEditingStart"
            @selection-changed="onSelectionChanged"
            @editor-preparing="onEditorPreparing"
          >
            <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

            <DxSelection :select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />

            <DxColumn
              data-field="grpAuthCd"
              caption="권한코드"
              data-type="string"
              width="250px"
              alignment="left"
              css-class="devest-grid-header-require"
            ></DxColumn>

            <DxColumn
              data-field="grpAuthNm"
              caption="권한이름"
              data-type="string"
              alignment="left"
              css-class="devest-grid-header-require"
            ></DxColumn>
            <DxColumn
              data-field="ordSeq"
              data-type="string"
              caption="순번"
              alignment="center"
              width="90px"
              css-class="devest-grid-header-require"
            />
            <DxColumn
              data-field="systemYn"
              data-type="boolean"
              caption="시스템권한"
              alignment="center"
              width="90px"
              edit-cell-template="checkBoxEditor"
            />
            <DxColumn
              data-field="clientYn"
              data-type="boolean"
              caption="고객권한"
              alignment="center"
              width="90px"
              edit-cell-template="checkBoxEditor"
            />
            <DxColumn
              data-field="useYn"
              data-type="boolean"
              caption="사용"
              alignment="center"
              width="90px"
              edit-cell-template="checkBoxEditor"
            />

            <!-- <DxColumn caption="" awllow-editing="true" data-type="string" /> -->

            <template #checkBoxEditor="{ data: cellInfo }">
              <DxCheckBox
                :value="cellInfo.value == 'Y' ? true : false"
                :onValueChanged="value => onCheckValueChanged(value, cellInfo)"
              />
            </template>
          </DxDataGrid>
        </template>
      </i-card-vertical>
      <i-card-right
        :useBtnList="buttonUseList"
        @btnAdd="btnAdd()"
        @btnSearch="btnSearch()"
        @btnSave="btnSave()"
        @btnDelete="btnDelete()"
      ></i-card-right>
    </v-sheet>
  </v-container>
</template>

<script>
import { getGroupData, updateGroupData, deleteGroupData } from '@/api/setting/groupManage'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'groupManage',
  components: {},
  data() {
    return {
      pageSizes: [5],
      showPageSizeSelector: true,
      dxDataGridRef: 'groupDataGrid',
      groups: [],
      buttonUseList: [
        'btnAdd', //추가
        'btnSearch', //조회
        'btnSave', //저장
        'btnDelete' //삭제
      ],
      allMode: 'allPages'
    }
  },
  computed: {},
  beforeMount() {},
  mounted() {
    this.btnSearch()
  },
  methods: {
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    //------------------------------------------
    //  그룹 조회
    //------------------------------------------
    btnSearch() {
      this.openLoading('searching')

      getGroupData(true)
        .then(res => {
          if (res.success) {
            this.gridInit(this.GetDataGrid(this.dxDataGridRef))

            //super 그룹을 상단에 고정
            // let index = res.list.findIndex(e => e.grpAuthCd === 'super')
            // let top = res.list.find(e => e.grpAuthCd === 'super')
            // res.list.splice(index, 1)
            // res.list.unshift(top)

            this.groups = res.list
            this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
          }
        })
        .catch(error => {})
        .finally(() => {
          this.endLoading()
        })
    },
    //------------------------------------------
    //  그룹 추가
    //------------------------------------------
    async btnAdd() {
      let newRow = {
        id: this.groups.length + 1,
        grpAuthCd: '',
        systemYn: 'Y',
        clientYn: 'N',
        useYn: 'Y'
      }
      Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })
      //this.groups.unshift(newRow)
      await this.GetDataGrid(this.dxDataGridRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridRef).selectRows(newRow.id, true)
    },
    //------------------------------------------
    //  그룹 저장
    //------------------------------------------
    btnSave() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then(selectedRows => {
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'info')
            return
          }
          this.vToastifyPrompt(
            this.$t('doSaveData'),
            'info',
            current => {
              this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()
              //필수 입력값 체크
              var index = selectedRows.findIndex(
                element =>
                  !element.grpAuthCd || /\s/.test(element.grpAuthCd) || !element.grpAuthNm || !element.ordSeq || !/^\d+$/.test(element.ordSeq)
              )
              if (index >= 0) {
                this.vToastify(this.$t('필수항목 입력하세요.<br>[권한코드, 권한이름, 순번]'), 'info')
                this.GetDataGrid(this.dxDataGridRef).endUpdate()
                return
              }

              this.openLoading('saving')
              //저장 api
              updateGroupData(selectedRows, true)
                .then(res => {
                  if (res.success) {
                    this.gridInit(this.GetDataGrid(this.dxDataGridRef))
                    selectedRows.forEach(element => (element.__created__ = false))
                  }
                })
                .catch(error => {
                  if (error.response && error.response.data) {
                    if (error.response.data.code == -2001) {
                      this.vToastify(this.$t(error.response.data.msg), 'info')
                    }
                  }
                })
                .finally(() => {
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  this.endLoading()
                })
            },
            null,
            true
          )
        })
    },
    //------------------------------------------
    //  그룹 삭제
    //------------------------------------------
    btnDelete() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then(selectedRows => {
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'info')
            return
          }
          this.vToastifyPrompt(
            this.$t('그룹을 삭제하시겠습니까?'),
            'info',
            current => {
              this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()

              // var index = selectedRows.findIndex(element => element.grpAuthCd == 'super')
              // if (index >= 0) {
              //   this.vToastify(this.$t('슈퍼유저 권한은 삭제할 수 없습니다.'), 'warn')
              //   this.GetDataGrid(this.dxDataGridRef).endUpdate()
              //   return
              // }

              this.openLoading('deleting')
              //삭제 api
              deleteGroupData(selectedRows, true)
                .then(res => {
                  if (res.success) {
                    this.deleteCallBack(selectedRows)
                  }
                })
                .catch(error => {})
                .finally(() => {
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
                  this.endLoading()
                })
            },
            null,
            true
          )
        })
    },

    ///////////////////////////////////////
    /*           DataGrid Event          */
    ///////////////////////////////////////
    onCheckValueChanged(value, cellInfo) {
      console.log('## ', value, cellInfo)
      cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
    },

    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    deleteCallBack(selectedRows) {
      var index = null
      selectedRows.forEach(key => {
        index = this.groups.findIndex(obj => obj == key)
        this.groups.splice(index, 1)
      })
    },

    onEditingStart(e) {
      //grpAuthCd는 추가된 행이 아니면 수정 불가능하게 설정
      if (e.column.dataField == 'grpAuthCd' && !e.data.__created__) e.cancel = true
      else e.cancel = false
      //super그룹 수정 불가능하게 설정
      // if (e.key === 'super') e.cancel = true
    },

    onSelectionChanged(e) {
      //super그룹 selection 불가능하게 설정
      // this.GetDataGrid(this.dxDataGridRef)
      //   .getSelectedRowKeys()
      //   .then(selectedRows => {
      //     selectedRows.forEach(element => {
      //       if (element === 'super') {
      //         this.GetDataGrid(this.dxDataGridRef).deselectRows(element)
      //         return
      //       }
      //     })
      //   })
    }
  }
}
</script>
<style scoped></style>
